<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.",
      "No records found.": "Nenhum registro encontrado.",
    },
    es: {
      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtelo de nuevo más tarde.",
      "No records found.": "No se encontraron registros.",
    },
  },
  components: {
    Layout,
    VclList,
    Stat,
  },
  data() {
    return {
      premiations: null,
      statData: null,
    };
  },
  methods: {
    getPremiations() {
      api.get("reports/premiations").then((response) => {
        if (response.data.status == "success") {
          this.premiations = response.data.list;

          this.statData = [
            {
              icon: "bx bx-dollar",
              title: "Total de Pontos",
              value: this.$options.filters.points(
                response.data.total
              ),
            },
          ];
        }
      });
    },
  },
  mounted() {
    this.getPremiations();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Relatórios</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Premiações</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="(stat, index) of statData" :key="index" class="col-md-6">
        <Stat
          :icon="stat.icon"
          :title="stat.title"
          :value="stat.value"
        />
      </div>
    </div>

    <vcl-list v-if="!premiations" class="col-lg-6 card card-body"></vcl-list>
    <div v-else class="card">
      <div class="card-body pt-4 px-4 pb-1">
        <div v-for="(row, index) in premiations" :key="index" class="d-md-flex align-items-center">
          <div v-if="row.image" class="premiation-image mb-4 text-center">
            <img
              :src="require('@/assets/images/premiations/' + row.image)"
              class="img-fluid rounded"
               style=""
            />
          </div>
          <div class="premiation-info flex-fill mb-4">
              <h5 class="mb-0 text-dark">{{ row.name }}</h5>
              <h4 class="mb-0 text-dark">
                {{ row.points | points }}
              </h4>
              <p class="m-0"> {{ row.vme | points }}</p>
            <b-progress
              style="border-radius: 3px"
              :value="Number(row.percent)"
              striped
              variant="warning"
              height="20px"
            ></b-progress>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.premiation-image {
  padding-right: 20px;
}
.premiation-image img {
  width:300px;
  height:200px;
  object-fit: cover;
}

@media (max-width: 575px) {
  .premiation-image {
    padding-right: 0;
  }
  .premiation-image img {
    width: 100%;
  }
}
</style>
